import Grid2 from '@mui/material/Unstable_Grid2';

import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import Button, { ButtonContent } from '@/components/OldButton/OldButton';
import { Contentful, FrontifyImageContent } from '@/contentful';
import { getFrontifyBackgroundImageUrl } from '@/utils/frontify';

import useStyles from './HeroTwoThirdsImage.styles';

export interface HeroTwoThirdsImageContent extends Contentful {
  fields: {
    title: string;
    body: string;
    image: FrontifyImageContent[];
    ctaButton: ButtonContent;
    imageAlignment: 'left' | 'right';
  };
}

interface Props {
  content: HeroTwoThirdsImageContent;
}

export default function Hero({ content }: Props) {
  const { title, body, image, ctaButton, imageAlignment } = content.fields;
  const imageUrl = image[0].preview_url;
  const { classes } = useStyles();

  return (
    <GridContainer2
      gridProps={{
        className: classes.heroContainer,
        style: {
          flexDirection: imageAlignment === 'left' ? 'row' : 'row-reverse',
        },
      }}
    >
      <Grid2
        className={classes.heroSection}
        style={{
          backgroundImage: getFrontifyBackgroundImageUrl(imageUrl, 1440),
        }}
        md={7}
        xs={12}
      />
      <Grid2
        md={5}
        xs={12}
        className={
          ctaButton ? classes.heroTextContainer : classes.heroTextContainerNoCTA
        }
      >
        <h1 className={classes.heroTitle}>{title}</h1>
        {body && <p className={classes.heroBody}>{body}</p>}
        {ctaButton && (
          <div className={classes.heroButtom}>
            <Button {...ctaButton?.fields} />
          </div>
        )}
      </Grid2>
    </GridContainer2>
  );
}
